











































































































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import LetterTabVue from "../components/LetterTab.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ViewAccountBookVue from "../components/AccountBookList/ViewAccountBook.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import version from "@/version";

@Component({
    ...mapGetters(["account", "searchKey"]),
    components: {
        "letter-tab": LetterTabVue,
        "month-selector": MonthSelectorVue,
        "view-book": ViewAccountBookVue,
        "user-tree": AllUserTreeVue,
    }
})
export default class TaxList extends Vue {
    pageNation: PageNation.PageNation = {
        currentPage: 1,
        pageSize: 13,
        totalElements: 1
    };
    taxList: Entry.Entry[] = []
    startPeriod: string = ""
    endPeriod: string = ""
    scope: string = "all";
    isTop: string = "146px"
    // 分页
    searchKey: string = "";
    changePage(val: number) {
        this.pageNation.currentPage = val;
        this.fetchData();
    }
    mounted() {
        // Date
        this.startPeriod = this.endPeriod = this.$store.state.collectPeriod;
    }
    //改变时间
    period: string[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.startPeriod = this.period[0];
        this.endPeriod = this.period[1];
        this.fetchData();
    }
    // 虚拟地址
    isVirtualAddress: boolean = false;
    get isVir() { return this.isVirtualAddress ? 1 : 0; }
    changeVir(val: boolean) {
        this.isVirtualAddress = val;
        this.fetchData();
    }
    // 获取数据
    accounterNo: string = this.$store.state.account.no;
    fetchData() {
        Vue.axios.post(
            `taxs/lists?page=${this.pageNation.currentPage - 1}&size=${this.pageNation.pageSize}`, {
            accounterNo: this.accounterNo,
            searchKey: this.searchKey,
            startPeriod: this.startPeriod,
            endPeriod: this.endPeriod,
            query: this.$store.state.searchKey,
            scope: this.scope,
            isVirtualAddress: this.isVir
        })
            .then(res => {
                res.data.taxList.content.forEach((v: any) => {
                    if (+v.copyTaxes === 0) v.copyTaxes = false;
                    else v.copyTaxes = true;
                    if (+v.finished === 0) v.finished = false;
                    else v.finished = true;
                    if (+v.report === 0) v.report = false;
                    else v.report = true;
                })
                this.taxList = res.data.taxList.content;
                this.pageNation.totalElements = Object.freeze(res.data.taxList.totalElements);
            });
    }
    // 选择框
    changeStatus(e: any, row: Entry.Entry) {
        let clo = JSON.parse(JSON.stringify(row));
        if (clo.copyTaxes) clo.copyTaxes = 1;
        else clo.copyTaxes = 0;
        if (clo.finished) clo.finished = 1;
        else clo.finished = 0;
        if (clo.report) clo.report = 1;
        else clo.report = 0;
        Vue.axios
            .post(`taxs/add`, clo)
            .then(res => {
                if (res.status != 200) this.fetchData();
                else row = res.data;
            }).catch(res => { this.fetchData() });
    }
    // 滚动
    ready: boolean = false;
    scrollLeft: number = 0;
    stepSize: number = 50;
    scroll(event: any) {
        //第一次滚动需要获取当前滚动位置
        let dataTable: any = document.querySelector(".data-table .el-table__body-wrapper");
        if (!this.ready) {
            this.scrollLeft = dataTable.scrollLeft;
            this.ready = true;
        }
        //firefox用detail反映滚动方向，而且方向和其他浏览器相反。其他浏览器用wheelDelta
        let direction = event.wheelDelta;
        //保证滚动到头的时候不再调用update函数
        if (this.scrollLeft <= 0 && direction > 0) {
            return;
        }
        if (this.scrollLeft >= 1000 && direction < 0) {
            return;
        }
        //根据鼠标滚动的方向确定是往左还是往右移动
        let distance = direction > 0 ? -this.stepSize : this.stepSize;
        this.update(distance, dataTable);
    }
    update(distance: any, dataTable: any) {
        this.scrollLeft += distance;
        dataTable.scrollLeft = this.scrollLeft; //针对webkit浏览器
    }
    // 修改客户
    showInfo: boolean = false;
    bookData: AccountBookList.Info | null = null;
    accountModify(data: AccountBookList.Info) {
        Vue.axios.get(`accountbooks/${data.accountBookId}`).then(res => {
            this.bookData = res.data;
            this.showInfo = true;
        });
    }
    closeInfo() {
        this.showInfo = false;
    }
    infoSuccess() {
        this.fetchData();
        this.showInfo = false;
    }

    // 导出报税列表
    exportTax() {
        this.$store.dispatch("toggleDownload", true);
        const state = this.$store.state;
        let url = `${Vue.axios.defaults.baseURL}export/taxclaim?startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&searchKey=${this.searchKey}&accounterNo=${state.account.no}&query=${state.searchKey}&token=${state.account.token}&version=${version}&scope=${this.scope}&isVirtualAddress=${this.isVir}`;
        this.$utils.sendToElectron("download", url);
    }
    // 所属人
    accounterName: string = "所属人姓名"
    // 打开tree
    isTree: boolean = false;
    openTree() {
        this.isTree = !this.isTree;
    }
    // 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
    tmp: UserTree | null = null;
    treeExpand(data: UserTree) {
        this.tmp = data;
    }
    // 点击tree中的名字(node)
    isScope: boolean = false
    handleNodeClick(data: Account) {
        this.isScope = true
        if (data.name) this.accounterName = data.name;
        this.pageNation.currentPage = 1;
        this.$store.dispatch("clearSearchKey");
        this.accounterNo = data.no
        this.scope = "accounterNo"
        this.fetchData();
        this.isTree = false;
    }
    // 关闭tree
    closeTree() {
        this.isTree = false;
    }
    // 批量勾选去除
    isCheckAll(command: number) {
        let report = 0;
        let finished = 0;
        let taxStatus = 0;
        if (command === 0) {
            report = 0;
            finished = 0;
            taxStatus = 0;
        } else {
            report = 1;
            finished = 1;
            taxStatus = 1;
        }
        if (this.checkTaxList.length === 0) {
            this.$message.warning("请勾选所需要修改的客户");
        } else {
            Vue.axios.post(
                `taxs/modify`, {
                report: report,
                finished: finished,
                copyTaxes: taxStatus,
                taxClaimRowDtoList: this.checkTaxList,
            })
                .then(res => {
                    this.fetchData()
                });
        }
    }
    // 主表多选
    checkTaxList: any = [];
    changeSelect(selection: any) {
        this.checkTaxList = JSON.parse(JSON.stringify(selection));
        this.checkTaxList.forEach((v: any) => {
            if (v.copyTaxes === false) v.copyTaxes = 0;
            else v.copyTaxes = 1;
            if (v.finished === false) v.finished = 0;
            else v.finished = 1;
            if (v.report === false) v.report = 0;
            else v.report = 1;
        })
    }
}
